export class ServerNameEnum {
    static map = new Map().set(1, "SQL.DBServerName").set(2, "name").set(6,"SQL.DBServerName").set(4,"SQL.DBServerName");
}